export default __webpack_public_path__ + "static/media/check_icon_aquamarine.c9767f79.png";